import React from "react";
import Icon from "../Icon/Icon.jsx";
import { string, array } from "prop-types";

const propTypes = {
  header: string,
  socialProfiles: array,
};

const SocialConnectIcons = (props) => {
  const { header, socialProfiles } = props;
  return (
    <div className="social-connect-icons">
      {header && <span className="social-connect-icons__header">{header}</span>}
      <div className="social-connect-icons__icons">
        {socialProfiles.map((profile, i) => (
          <a
            className={`social-connect-icons__button ${
              profile.linkClass || ""
            }`}
            href={profile.href}
            target="_blank"
            title={profile.text}
            rel="noopener noreferrer"
            key={i}
          >
            <Icon className="icon--32x32" iconName={profile.icon} />
          </a>
        ))}
      </div>
    </div>
  );
};

SocialConnectIcons.propTypes = propTypes;
export default SocialConnectIcons;
